import { apiClient } from 'api'
import { EditTrainingGameFormData, NewTrainingGameFormData, TrainingGame } from 'types/games'

export const getTrainingGames = () => apiClient.get<TrainingGame[]>('/training-games')

export const getTrainingGameById = (gameId: number) => apiClient.get<TrainingGame>(`/training-games/${gameId}`)

export const createTrainingGame = (game: NewTrainingGameFormData) =>
    apiClient.post<NewTrainingGameFormData, TrainingGame>('/training-games', game)

export const editTrainingGame = (game: EditTrainingGameFormData) =>
    apiClient.patch<EditTrainingGameFormData>(`/training-games/${game.id}`, game)

export const deleteTrainingGame = (id: number) => apiClient.delete(`/training-games/${id}`)
